import GeoFenceMap from '../components/GeoFenceMap.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import geoFenceEscl from '../locales/es-CL/geoFence.json';
import geoFenceEsmx from '../locales/es-MX/geoFence.json';
import geoFenceEsco from '../locales/es-CO/geoFence.json';
import geoFenceEnus from '../locales/en-US/geoFence.json';
//import inputGeoFences from '../geoFence/inputGeoFences.json';
import showConfirmation from '../confirmation/confirmationHandler';
import showAlert from '../alert/alertHandler';

import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import axios from 'axios';

export default {
  name: 'GeoFence',
  components: { GoogleMapsApiLoader, GeoFenceMap, BuscadorDirecciones},
  i18n: {
    messages: {
      'es-CL': {
        geoFence: geoFenceEscl,
      },
      'es-MX': {
        geoFence: geoFenceEsmx,
      },
      'es-CO': {
        geoFence: geoFenceEsco,
      },
      'en-US': {
        geoFence: geoFenceEnus,
      },
    },
  },
  data() {
    return {
      dataAccess: null,
      isMainPageBussy: false,
      isFilterApplied: false,
      isFilterShown: false,
      isFilterClicked: false,
      isEditMode: false,
      perPage: 10,
      currentPage: 1,
      perPageArchived: 10,
      currentPageArchived: 1,
      pageOptions: [10, 20, 50, 100],
      selectedGeoFences: [],
      selectedArchivedGeoFences: [],
      gapi: null,
      currentTab: 'geoFence',
      filterKeyword: null,
      geoFences: [],
      archived: [],
      crudMode: false,
      //Valores para usar en el crear y update
      selectedId: null,
      geoFencesEdit: [],
      selectedName: null,
      //Modal de confirmacion
      selectedGeoFence: null,
      title: null,
      message: null,
      deactivate: null,
      address: null,
    };
  },
  async created() {
    this.isMainPageBussy = true;
    await GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData();
  },
  methods: {
    /**
     * Funciones para desactivar el filtro clickeando fuera de la pantalla
     */
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    async receiveAddressInformation(address){
      if (address.streetName !== '') {
        console.log("Mapa ",address);
        await this.$refs.map.setMapCenter(this.gapi,address.coordinates);
      }
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      await this.getGeoFences();
      this.isMainPageBussy = false;
    },
    async getGeoFences() {
      try{
        this.geoFences = [];
        this.archived = []; 
        const urlGeofence = `${this.$store.getters.urlAPI}/geofence`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlGeofence, config);
        let geoFences = response.data.data;
        geoFences.forEach((gFence) => {
          if (gFence.archived) {
            this.archived.push(gFence);
          } else {
            this.geoFences.push(gFence);
          }
        });
        this.geoFences = this.geoFences.sort((a, b) => this.sortRules(a, b));
        let indexUnarchive = 0;
        this.geoFences.forEach((g)=>{
          indexUnarchive += 1;
          g.index = indexUnarchive
        })
        this.archived = this.archived.sort((a, b) => this.sortRules(a, b));
        let indexArchive = 0;
        this.archived.forEach((g)=>{
          indexArchive += 1;
          g.index = indexArchive
        })
      }catch(e){
        console.log(e);
        this.geoFences = [];
        this.archived = [];
      }
    },
    limitText(count) {
      return this.$t('common.search.limitText') + (count + 1);
    },
    sortRules(a, b) {
      // Primero ordenar por activos (true primero)
      if (a.active && !b.active) {
        return -1;
      } else if (!a.active && b.active) {
        return 1;
      }
      // Si las cantidades son iguales, ordenar por nombre
      return a.name.localeCompare(b.name);
    },
    async changeTab(navBar) {
      this.filterKeyword = null;
      await this.cleanMap();
      this.currentTab = navBar;
      if(this.currentTab === 'geoFence'){
        this.selectedArchivedGeoFences = [];
      }
      if(this.currentTab === 'archived'){
        this.selectedGeoFences = [];
      }
    },
    async editGeoFence(geoFence){
      this.selectedId = geoFence.id;
      this.selectedName = geoFence.name;
      this.geoFencesEdit = geoFence.zone;
      this.isEditMode = true;
      await this.enterCrud();
      await this.$refs.map.setEditPolygon(this.gapi,geoFence);
    },
    async confirmToogleActiveGeofence(geoFence){
      let isActive = geoFence.active;
      let firstTimeActive = this.readCookie('firstTimeActive');
      if(firstTimeActive === null){
        document.cookie = `firstTimeActive=${true}; SameSite=Lax;`;
      }
      firstTimeActive = this.readCookie('firstTimeActive');
      //Si es primera vez que lo activare o si la geocerca esta activa, gatillara este modal
      if(firstTimeActive === 'true' && isActive){
        //Como en el front hizo cambio visual el check, se hace cambio manual del estado de la activación
        geoFence.active = !geoFence.active;
        this.selectedGeoFence = geoFence;
        this.selectedGeoFence.isActive = isActive;
        this.title = this.$t('geoFence.modal.title.deactivate', {name: geoFence.name});
        this.message = this.$t('geoFence.modal.body.deactivate');
        this.deactivate = this.$t('geoFence.button.deactivate')
        this.showModal('confirmation-modal');
      }else{
        this.toogleActiveGeofence(geoFence,isActive);
      }
    },
    async aceptActive(id){
      await this.toogleActiveGeofence(this.selectedGeoFence, this.selectedGeoFence.isActive);
      document.cookie = `firstTimeActive=${false}; SameSite=Lax;`;
      this.closeModal(id);
    },
    cancelActive(id){
      console.log(this.selectedGeoFence);
      this.geoFences.forEach((g)=>{
        if(g.id === this.selectedGeoFence.id){
          // Este cambio pasivo de nombre es para activar la actualización del check
          const name = g.name;
          g.name = '';
          g.name = name; 
          g.active = true;
        }
      })
      this.closeModal(id);
    },
    async toogleActiveGeofence(geoFence,actualState){
      try{
        const url = `${this.$store.getters.urlAPI}/geofence/${geoFence.id}/changeActive`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {};
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          geoFence.active = !actualState;
        }
      }catch(e){
        geoFence.active = actualState;
        console.log(e);
      }
    },
    /**
     * Este metodo carga la vista para crear geocercas
     */
    async enterCrud() {
      this.crudMode = true;
      this.getGeoFencePoints();
      await this.changeMapMode('edit');
      await this.cleanMap();
      this.selectedGeoFences = [];
      this.selectedArchivedGeoFences = [];
    },
    /**
     * Prepara la vista para volver a donde se visualizan las geocercas
     */
    async cleanCrud() {
      this.crudMode = false;
      this.isEditMode = false;
      await this.changeMapMode('view');
      await this.cleanMap();
      this.selectedName = null;
      this.selectedId = null;
      this.geoFencesEdit = [];
    },
    async cleanMap(){
      await this.$refs.map.setMapNull();
    },
    async changeMapMode(mode){
      await this.$refs.map.changeMode(mode);
    },
    /**
     * Consulta antes de querer archivar una geocerca
     * @param {*} geoFence 
     */
    archiveGeonfenceConfirm(geoFence) {
      let firstTimeArchive = this.readCookie('firstTimeArchive');
      if(firstTimeArchive === null){
        document.cookie = `firstTimeArchive=${true}; SameSite=Lax;`;
      }
      firstTimeArchive = this.readCookie('firstTimeArchive');
      if(firstTimeArchive === 'true'){
        showConfirmation(
          this.$t('geoFence.modal.title.archive', {name: geoFence.name}),
          this.$t('geoFence.modal.body.archive'),
          async () => {
            await this.archiveGeonfence(geoFence);
            document.cookie = `firstTimeArchive=${false}; SameSite=Lax;`;
          },
        )
      }else{
        showConfirmation(
          this.$t('geoFence.modal.title.archive', {name: geoFence.name}),
          this.$t('geoFence.modal.body.quickArchive'),
          async () => {
            await this.archiveGeonfence(geoFence);
          },
        )
      }
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    async archiveGeonfence(geoFence) {
      try{
        const url = `${this.$store.getters.urlAPI}/geofence/changeArchived`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = [
          geoFence.id
        ];
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          geoFence.archived = true;
          geoFence.active = false;
          const indice = this.geoFences.findIndex((geoF) => geoF.id === geoFence.id);
          if (indice >= 0) {
            this.geoFences.splice(indice, 1);
          }
          this.archived.push(geoFence);
          this.geoFences = this.geoFences.sort((a, b) => this.sortRules(a, b));
          this.archived = this.archived.sort((a, b) => this.sortRules(a, b));
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
        }
      }catch(e){
        console.log(e)
      }
    },
    archiveGeonfenceMasiveConfirm() {
      let firstTimeArchive = this.readCookie('firstTimeArchive');
      if(firstTimeArchive === null){
        document.cookie = `firstTimeArchive=${true}; SameSite=Lax;`;
      }
      firstTimeArchive = this.readCookie('firstTimeArchive');
      if(firstTimeArchive === 'true'){
        showConfirmation(
          this.$t('geoFence.modal.title.massArchive'),
          this.$t('geoFence.modal.body.massArchive'),
          async () => {
            await this.archiveGeonfenceMassive();
            document.cookie = `firstTimeArchive=${false}; SameSite=Lax;`;
          },
        )
      }else{
        this.archiveGeonfenceMassive();
      }
    },
    async archiveGeonfenceMassive() {
      try{
        const url = `${this.$store.getters.urlAPI}/geofence/changeArchived`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = this.selectedGeoFences;
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          const fullGeoFence = this.geoFences.filter((gf) => this.selectedGeoFences.includes(gf.id));
          if (fullGeoFence.length > 0) {
            fullGeoFence.forEach((geoFence) => {
              geoFence.archived = true;
              geoFence.active = false;
              const indice = this.geoFences.findIndex((geoF) => geoF.id === geoFence.id);
              if (indice >= 0) {
                this.geoFences.splice(indice, 1);
              }
              this.archived.push(geoFence);
              this.geoFences = this.geoFences.sort((a, b) => this.sortRules(a, b));
              this.archived = this.archived.sort((a, b) => this.sortRules(a, b));
            });
            showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
          }
        }
      }catch(e){
        console.log(e);
      }
      this.selectedGeoFences = [];
    },
    unarchiveConfirm(geoFence) {
      let firstTimeUnArchive = this.readCookie('firstTimeUnArchive');
      if(firstTimeUnArchive === null){
        document.cookie = `firstTimeUnArchive=${true}; SameSite=Lax;`;
      }
      firstTimeUnArchive = this.readCookie('firstTimeUnArchive');
      if(firstTimeUnArchive === 'true'){
        showConfirmation(
          this.$t('geoFence.modal.title.unarchive', {name: geoFence.name}),
          this.$t('geoFence.modal.body.unArchive'),
          async () => {
            await this.unarchiveGeoFence(geoFence);
            document.cookie = `firstTimeUnArchive=${false}; SameSite=Lax;`;
          },
        )
      }else{
        this.unarchiveGeoFence(geoFence);
      }
    },
    async unarchiveGeoFence(geoFence) {
      try{
        const url = `${this.$store.getters.urlAPI}/geofence/changeArchived`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = [
          geoFence.id
        ];
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          geoFence.active = false;
          geoFence.archived = false;
          const indice = this.archived.findIndex((geoF) => geoF.id === geoFence.id);
          if (indice >= 0) {
            this.archived.splice(indice, 1);
          }
          this.geoFences.push(geoFence);
          this.geoFences = this.geoFences.sort((a, b) => this.sortRules(a, b));
          this.archived = this.archived.sort((a, b) => this.sortRules(a, b));
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
        }
      }catch(e){
        console.log(e);
      }
    },
    unArchiveGeonfenceMasiveConfirm() {
      let firstTimeUnArchive = this.readCookie('firstTimeUnArchive');
      if(firstTimeUnArchive === null){
        document.cookie = `firstTimeUnArchive=${true}; SameSite=Lax;`;
      }
      firstTimeUnArchive = this.readCookie('firstTimeUnArchive');
      if(firstTimeUnArchive === 'true'){
        showConfirmation(
          this.$t('geoFence.modal.title.massUnArchive'),
          this.$t('geoFence.modal.body.unArchive'),
          async () => {
            await this.unArchiveGeonfenceMassive();
            document.cookie = `firstTimeUnArchive=${false}; SameSite=Lax;`;
          },
        )
      }else{
        this.unArchiveGeonfenceMassive();
      }
    },
    async unArchiveGeonfenceMassive() {
      try{
        const url = `${this.$store.getters.urlAPI}/geofence/changeArchived`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = this.selectedArchivedGeoFences;
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          const fullGeoFence = this.archived.filter((gf) => this.selectedArchivedGeoFences.includes(gf.id));
          if (fullGeoFence.length > 0) {
            fullGeoFence.forEach((geoFence) => {
              geoFence.archived = false;
              geoFence.active = false;
              const indice = this.archived.findIndex((geoF) => geoF.id === geoFence.id);
              if (indice >= 0) {
                this.archived.splice(indice, 1);
              }
              this.geoFences.push(geoFence);
              this.geoFences = this.geoFences.sort((a, b) => this.sortRules(a, b));
              this.archived = this.archived.sort((a, b) => this.sortRules(a, b));
            });
            
            showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
          }
        }
      }catch(e){
        console.log(e);
      }
      this.selectedGeoFences = [];
    },
    /**
     * Cuando selecciono una geocerca esta es dibujada en el mapa
     */
    async selectGeoFence() {
      this.isMainPageBussy = true;
      console.log(this.selectedGeoFences);
      const geoFences = this.geoFences.filter((g) => this.selectedGeoFences.includes(g.id));
      if (geoFences.length > 0) {
        const isArchived = false;
        console.log("Gapi ",this.gapi);
        await this.$refs.map.setGeoFences(this.gapi, geoFences, isArchived);
      }else{
        this.cleanMap();
      }
      this.isMainPageBussy = false;
    },
    async selectArchivedGeoFence() {
      this.isMainPageBussy = true;
      const geoFences = this.archived.filter((g) => this.selectedArchivedGeoFences.includes(g.id));
      if (geoFences.length > 0) {
        const isArchived = true;
        await this.$refs.map.setGeoFences(this.gapi, geoFences, isArchived);
      }
      this.isMainPageBussy = false;
    },
    async saveGeoFence(){
      try{
        this.isMainPageBussy = true;
        const url = `${this.$store.getters.urlAPI}/geofence`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {
          name: this.selectedName,
          zone: this.getGeoFencePoints(),
          vehicles: []
        };
        const response = await axios.post(url, body, config);
        if(response.data.status){
          await this.getGeoFences();
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
          this.cleanCrud();
          this.isMainPageBussy = false;
        }
      }catch(e){
        this.isMainPageBussy = false;
        console.log(e);
      }
    },
    async updateGeoFence(){
      try{
        this.isMainPageBussy = true;
        const url = `${this.$store.getters.urlAPI}/geofence/${this.selectedId}`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const newPoints = this.getGeoFencePoints();
        const haveNewPoints = this.checkChangePoints(this.geoFencesEdit, newPoints);
        let body = {
          name: this.selectedName,
          vehicles: [],
        };
        if(haveNewPoints){
          body = {
            ...body,
            zone: newPoints
          }
        }
        const response = await axios.patch(url, body, config);
        if(response.data.status){
          await this.getGeoFences();
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('geoFence.modal.success'));
          this.cleanCrud();
          this.isMainPageBussy = false;
        }
      }catch(e){
        this.isMainPageBussy = false;
        console.log(e);
      }
    },
    /**
     * Metodo que retorna si es que los puntos anitguos son iguales o no a los nuevos
     * @param {*} oldPoints 
     * @param {*} newPoints 
     * @returns 
     */
    checkChangePoints(oldPoints, newPoints){
      // Verificar si los arrays tienen la misma longitud
      if (oldPoints.length !== newPoints.length) {
        return true;
      }

      // Iterar sobre los elementos de los dos arrays
      for (let i = 0; i < oldPoints.length; i++) {
        const oldPoint = oldPoints[i];
        const newPoint = newPoints[i];

        // Comparar las coordenadas
        if (oldPoint.lat !== newPoint.lat || oldPoint.lon !== newPoint.lon) {
            // Si las coordenadas son diferentes, devolver true
            return true;
        }
      }

      // Si no se encontraron diferencias, devolver false
      return false;
    },
    getGeoFencePoints(){
      return this.$refs.map.getZonePoints();
    },
    readCookie(name) {
      return (
        decodeURIComponent(
          document.cookie.replace(
            new RegExp('(?:(?:^|.*;)\\s*' + name.replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'),
            '$1',
          ),
        ) || null
      );
    },
    filterTable(row, filter) {
      if(filter.keyword){
        let filterValue = false;
        if(filter.keyword && row.name.includes(filter.keyword)){
          filterValue = true;
        }
        return filterValue;
      }else{
        this.isFilterApplied = false;
        return true;
      }
    },
  },
  computed: {
    isAvaiableSave() {
      return this.selectedName && this.getGeoFencePoints().length > 2 ? true : false;
    },
    criteria(){
      return {
        keyword: this.filterKeyword,
      }
    },
    geoFenceData() {
      return this.geoFences.map((g) => {
        return {
          ...g,
        };
      });
    },
    archivedData() {
      return this.archived.map((g) => {
        return {
          ...g,
        };
      });
    },
    geoFenceField() {
      const common = {
        class: 'text-center',
        tdClass: 'small align-middle',
      };
      return [
        {
          key: 'select',
          label: this.$t('geoFence.fields.show'),
          ...common,
        },
        {
          key: 'index',
          label: 'ID',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('geoFence.fields.name'),
          ...common,
        },
        {
          key: 'active',
          label: this.$t('geoFence.fields.active'),
          ...common,
        },
        {
          key: 'actions',
          label: '',
          ...common,
        },
      ];
    },
    archivedField() {
      const common = {
        class: 'text-center',
        tdClass: 'small align-middle',
      };
      return [
        {
          key: 'select',
          label: this.$t('geoFence.fields.show'),
          ...common,
        },
        {
          key: 'index',
          label: 'ID',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('geoFence.fields.name'),
          ...common,
        },
        {
          key: 'actions',
          label: '',
          ...common,
        },
      ];
    },
  },
};
